import React, {useState} from "react";
import "@/../sass/components/manage/ProfilePhotoManagement.scss";

export default function ProfilePhotoManagement({ photoUrl,
                                                   onFileUploaded = () => {},
                                                   profileName = 'Your Profile'
                                               }) {
    const [state, setState] = useState({photoUrl: photoUrl})

    function onUploaded(data) {
        setState({...state, photoUrl: data.url})

        onFileUploaded(data)
    }

    return (
        <div className="profile-photo-container">
            {state.photoUrl &&
                <div className="profile-photo-management">
                    <div>
                        <img src={state.photoUrl}
                             className="profile-photo"
                             alt={`${profileName} photo`}
                             title={`${profileName} photo`} />
                    </div>
                </div>
            }
            {/*<UploadProfilePhoto*/}
            {/*    onUploaded={onUploaded}*/}
            {/*    showUploader={true}/>*/}
        </div>
    )
}
